export const dateFormat = 'dd.MM.yyyy';
